// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__CRC76","title":"Info_title__Ex4JU","selects":"Info_selects__7ZRfz","requiredAsterisk":"Info_requiredAsterisk__3Ivt6"};